import { Tab, Tabs, Theme, styled, alpha, Select, FormControl } from '@material-ui/core';

export const StyledTabs = styled(Tabs)<Theme>(({ theme }) => ({
  width: '100%',
  '& .MuiTabs-scroller .MuiTabs-indicator': {
    backgroundColor: theme.palette.primary.main,
    height: 3,
  },
}));

export const StyledTab = styled(Tab)<Theme>(({ theme }) => ({
  '&.MuiTab-root': {
    textTransform: 'none',
    height: theme.config.subHeaderHeightPx,
    borderTopLeftRadius: theme.config.defaultBorderRadius,
    borderTopRightRadius: theme.config.defaultBorderRadius,
    minWidth: 'clamp(80px, 7vw, 100px)',
    fontWeight: 600,
    paddingBottom: theme.spacing(1),
    '&:hover': {
      backgroundColor: alpha(theme.palette.grey['A100'], 0.1),
    },
    '&.Mui-selected': {
      color: theme.palette.primary.main,
    },
    '&.Mui-disabled': {
      fontWeight: 400,
      '&.attention::before': {
        content: '""',
        width: 5,
        height: 5,
        marginRight: 4,
        borderRadius: '50%',
        backgroundColor: theme.palette.primary.main,
      },
    },
  },
}));

export const MenuFilterWrapper = styled('div')<Theme>(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: theme.spacing(1),
}));

export const StyledFormControl = styled(FormControl)<Theme>(({ theme }) => ({
  marginRight: 'auto',
  padding: theme.spacing(1),
  height: theme.config.subHeaderHeightPx,
  '&.MuiFormControl-root': {
    '&:hover': {
      backgroundColor: alpha(theme.palette.grey['A100'], 0.1),
    },
    borderBottom: `3.5px solid ${theme.palette.primary.main}`,
  },
}));

export const StyledSelect = styled(Select)<Theme>(({ theme }) => ({
  '& .MuiListItemText-primary': {
    fontWeight: 600,
    opacity: 0.7,
    fontSize: '1.4rem',
  },
  '&.MuiInputBase-root': {
    // color: theme.palette.primary.main,
    '&.MuiInput-underline': {
      '&::before, &::after': {
        content: 'none',
      },
    },
  },
}));

export const StyledAuthorDiv = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
});
